import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Authenticated API client.
 * Auth flows through httpOnly cookies (session_token) which the browser
 * attaches automatically thanks to `withCredentials: true`. We deliberately
 * do NOT keep tokens in localStorage to avoid XSS exfiltration.
 */
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});
